import { reactive } from '@vue/composition-api'
import { ModalOptions } from 'ant-design-vue/types/modal'

function useModal(attrs: ModalOptions = {}, events: ModalOptions = {}) {
  const modalAttrs = reactive({
    title: '',
    visible: false,
    width: 960,
    confirmLoading: false,
    destroyOnClose: true,
    maskClosable: false,
    ...attrs,
  })

  const modalEvents = {
    ok() {},
    cancel() {
      modalAttrs.visible = false
    },
    ...events,
  }

  function open() {
    modalAttrs.visible = true
  }

  function close() {
    modalAttrs.visible = false
  }

  function showLoading() {
    modalAttrs.confirmLoading = true
  }

  function hideLoading() {
    modalAttrs.confirmLoading = false
  }

  return {
    modalAttrs,
    modalEvents,

    open,
    close,
    showLoading,
    hideLoading
  }
}

export default useModal
